export default __webpack_public_path__ + "static/media/twitterLight.c29db6c6.svg";